import { fieldLimits } from "config";
import React, { type ChangeEvent, useCallback } from "react";

import type { ReferenceLinkDraft } from "./entityForms.types";
import LineIcon from "./LineIcon";

import formStyles from "./formDialog.module.css";
import styles from "./ReferenceLinkRow.module.css";

type ReferenceLinkRowProps = {
	link: ReferenceLinkDraft;
	onChange: (id: string, url: string) => void;
	onRemove: (id: string) => void;
	removeLabel: string;
	urlLabel: string;
};

/** One editable external-reference URL with a remove button. */
const ReferenceLinkRow = ({ link, onChange, onRemove, removeLabel, urlLabel }: ReferenceLinkRowProps) => {
	const onUrlChange = useCallback(
		(event: ChangeEvent<HTMLInputElement>): void => onChange(link.id, event.target.value),
		[link.id, onChange]
	);
	const onRemoveClick = useCallback((): void => onRemove(link.id), [link.id, onRemove]);

	return (
		<div className={styles.referenceLinkRow}>
			<div className={formStyles.personFormField}>
				<input
					aria-label={urlLabel}
					maxLength={fieldLimits.referenceLink}
					onChange={onUrlChange}
					placeholder={urlLabel}
					type="url"
					value={link.url}
				/>
			</div>
			<button
				aria-label={removeLabel}
				className={styles.referenceLinkRemove}
				onClick={onRemoveClick}
				type="button">
				<LineIcon name="trash" />
			</button>
		</div>
	);
};

export default ReferenceLinkRow;
